import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Plus, Remove } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
import { Slider } from "@air/primitive-slider";
import { memo, useCallback } from "react";
export const ZoomSlider = /*#__PURE__*/ memo((param)=>{
    let { onZoomIn, onZoomOut, zoom, onSliderChange, min = 0.5, max = 3, step = 0.1 } = param;
    const handleValueChange = useCallback((value)=>{
        if (onSliderChange) {
            onSliderChange(value);
        }
    }, [
        onSliderChange
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex w-[160px] items-center gap-2",
        "data-testid": "ZOOM_SLIDER",
        children: [
            /*#__PURE__*/ _jsx(IconButton, {
                onClick: onZoomOut,
                icon: Remove,
                label: "Zoom out",
                appearance: "ghost",
                color: "grey",
                size: "medium",
                "data-testid": "ZOOM_OUT_BUTTON"
            }),
            /*#__PURE__*/ _jsx(Slider, {
                defaultValue: [
                    zoom
                ],
                formatTooltip: (values)=>"".concat(Math.round(values[0] * 100), "%"),
                tooltipPosition: "top",
                tooltipDisplayStrategy: "on-drag",
                value: [
                    zoom
                ],
                max: max,
                min: min,
                step: step,
                rangeColor: "grey",
                onValueChange: handleValueChange
            }),
            /*#__PURE__*/ _jsx(IconButton, {
                onClick: onZoomIn,
                icon: Plus,
                label: "Zoom in",
                appearance: "ghost",
                color: "grey",
                size: "medium",
                "data-testid": "ZOOM_IN_BUTTON"
            })
        ]
    });
});
ZoomSlider.displayName = "ZoomSlider";
